<script setup>
import { computed } from 'vue';

/* Props */
const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  tooltipText: {
    type: String,
    default: '',
  },
});

const hasTooltipText = computed(() => props.tooltipText && props.tooltipText !== 'undefined');
</script>

<template>
  <div class="app__tooltip">
    <!-- eslint-disable vue/no-v-text-v-html-on-component -->
    <g-tooltip>
      <span
        slot="tooltip-title"
        v-html="props.title"
      />
      <g-copy
        v-if="hasTooltipText"
        slot="tooltip-text"
        type="small"
        v-html="props.tooltipText"
      />
    </g-tooltip>
    <!-- eslint-enable vue/no-v-text-v-html-on-component -->
  </div>
</template>

<style lang="scss" scoped>
.app__tooltip {
  @include font-size(small); // 14px
  width: 100%;

  :deep(.g__tooltip__icon) {
    margin-top: -1px;
    width: 1.125rem; // 18px
    margin-inline-start: 0.25rem; // 4px
  }

  :deep(.g__tooltip__summary) {
    line-height: inherit;
    margin-bottom: 0.5rem;
    width: max-content;
  }

  &__title {
    @include font-primary-weight-medium();
  }
}
</style>
